import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {GeneralConfig} from '../shared/GeneralConfig';
import {MiniBookAdminService} from './mini-book-admin.service';

@Injectable()
export class GeneralconfigPublicService {

  constructor(private http: HttpClient, private admin: MiniBookAdminService) { }

  getGeneralConfig(): Observable<GeneralConfig> {
    return this.http.get<GeneralConfig>(`${environment.url}${this.admin.tenant}/generalconfig`).pipe(
      map(data => GeneralConfig.createFromJson(data))
    );
  }

}
